import { Button, Heading, Text } from "@/design-system";
import { motion } from "framer-motion";
import { WhatsAppLinkButton } from "./WhatsAppLinkButton";
import { PageSection } from "@/pages/landingPage/components/pageSection";

type CobrancaHeroProps = {
  onDemoClick: () => void;
};

export const CobrancaHero = ({ onDemoClick }: CobrancaHeroProps) => (
  <PageSection labelledBy="hero-title" className="pt-28 lg:pt-36">
    <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-12">
      {/* Texto sem animação de entrada: o h1 é o LCP no celular e precisa
          aparecer no primeiro paint. */}
      <div className="flex flex-col gap-6">
        <Heading level={1} id="hero-title" className="md:text-ds-display">
          Cobrança via WhatsApp para redes de lojas
        </Heading>

        <Text size="lead" tone="muted" className="max-w-prose">
          A Fidexa automatiza a cobrança do crediário próprio pelo WhatsApp:
          régua personalizada, recuperação de crédito e menos inadimplência, com
          todas as lojas da sua rede em um só painel.
        </Text>

        <div className="flex flex-col gap-3 sm:flex-row">
          <Button size="lg" onClick={onDemoClick}>
            Agendar demonstração
          </Button>
          <WhatsAppLinkButton location="hero" />
        </div>
      </div>

      <motion.div
        className="flex justify-center lg:justify-end"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.24, ease: "easeOut" }}
      >
        <img
          src="/images/header-fidexa.png"
          alt="Lojista sorrindo enquanto usa o celular dentro de uma loja de roupas"
          width={748}
          height={735}
          className="h-auto w-full max-w-md"
          fetchPriority="high"
        />
      </motion.div>
    </div>
  </PageSection>
);
